<script setup lang="ts">
import VacaturesDataTable from '@/features/vacatures/components/VacaturesDataTable.vue'

definePage({
  path: '/vacatures',
  name: 'vacatures.overview',
  meta: {
    title: 'Vacatures',
    permission: {
      resource: 'Job',
      level: 'Read',
    },
  },
})
</script>

<template>
  <div class="space-y-5">
    <Card>
      <template #content>
        <VacaturesDataTable title="Vacatures" />
      </template>
    </Card>
  </div>
</template>
